import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap, tap } from 'rxjs/operators';
import { MonitoringHttpService } from '@services/http/monitoring/monitoring-http.service';
import { ToastHelperService } from '@services/helpers/toast-helper.service';
import * as MonitoringActions from './monitoring.actions';

@Injectable()
export class MonitoringEffects {
  loadClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MonitoringActions.loadClients),
      switchMap(({ filters }) =>
        this.monitoringHttpService.getClients(filters).pipe(
          map(clients => MonitoringActions.loadClientsSuccess({ clients: clients || [] })),
          catchError(error => {
            const errorMessage = error?.message || 'Erro ao carregar clientes';
            this.toastHelper.showToastError(errorMessage);
            return of(MonitoringActions.loadClientsFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  loadStatusColumns$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MonitoringActions.loadStatusColumns),
      switchMap(() =>
        this.monitoringHttpService.getStatusColumns().pipe(
          map(columns => MonitoringActions.loadStatusColumnsSuccess({ columns: columns || [] })),
          catchError(error => {
            const errorMessage = error?.message || 'Erro ao carregar colunas de status';
            this.toastHelper.showToastError(errorMessage);
            return of(MonitoringActions.loadStatusColumnsFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  updateClientStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MonitoringActions.updateClientStatus),
      switchMap(({ clientId, status }) =>
        this.monitoringHttpService.updateClientStatus(clientId, status).pipe(
          map(() => {
            this.toastHelper.showToastSuccess('Status atualizado com sucesso');
            return MonitoringActions.updateClientStatusSuccess({ clientId, status });
          }),
          catchError(error => {
            const errorMessage = error?.message || 'Erro ao atualizar status';
            this.toastHelper.showToastError(errorMessage);
            return of(MonitoringActions.updateClientStatusFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private monitoringHttpService: MonitoringHttpService,
    private toastHelper: ToastHelperService
  ) {}
}
